module.exports = __webpack_public_path__ + "f70f54723a097209cfed100eb8198799.png";